export function register() {
  console.log("Registrando service worker", navigator)
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      navigator.serviceWorker.register(swUrl)
        .then((registration) => {
          console.log('Service worker registrado com sucesso!', registration);
        })
        .catch((error) => {
          console.error('Erro durante o registro do service worker:', error);
        });
    });
  }
}

/**
 * Remove QUALQUER service worker registrado e limpa os caches do site.
 *
 * `navigator.serviceWorker.ready` só resolve quando existe um SW ativo — se o
 * registro estivesse em outro estado, o unregister antigo simplesmente nunca
 * rodava. Aqui varremos todas as registrations e apagamos os caches.
 *
 * O app não usa Web Push (nenhum pushManager.subscribe no frontend, nenhum
 * web-push no backend), então não há nada a preservar ao remover o SW.
 *
 * Isto só roda depois que o bundle novo carrega. Quem já está preso no bundle
 * antigo é resgatado pelo kill-switch em public/service-worker.js.
 */
export function unregister() {
  if (!('serviceWorker' in navigator)) return;

  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) =>
      Promise.all(registrations.map((registration) => registration.unregister()))
    )
    .then(() => {
      if (!('caches' in window)) return undefined;
      return caches
        .keys()
        .then((keys) => Promise.all(keys.map((key) => caches.delete(key))));
    })
    .catch((error) => {
      console.error('Erro durante o desregistro do service worker:', error);
    });
}
